import React from 'react';
import Header from './Header';
import skills from '../json/skills.json';
import mobile from '../svgs/mobile.svg';
import code from '../svgs/code.svg';
import laptop from '../svgs/laptop.svg';
import gamepad from '../svgs/gamepad.svg';
import palette from '../svgs/palette.svg';
import keyboard from '../svgs/keyboard.svg';
import util from '../svgs/paint-util.svg';
import { motion } from 'framer-motion';

function Skills() {
	const icons = [code, mobile, laptop, gamepad, util, palette, keyboard];

	return (
		<React.Fragment>
			<Header appTitle="Skills" />
			<div className="main-body skills-page pd-md-v xl-pd-none">
				{skills.map((skill, index) => {
					return (
						<div key={index} className="each-data flex align-center flex-column md-no-column justify-center sp-xl-bottom elevate">
							<div className="banner flex align-center justify-center bg-fixed">
								<img className="sp-lg-h" src={icons[index]} alt="icon" />
							</div>
							<div className="flex flex-column flex-grow justify-center pd-md">
								<h2 className="txt-primary sp-bottom">{skill.title}</h2>
								<p className="">{skill.description}</p>
								<div className="flex flex-column">
									<div className="flex align-center flex-wrap sp-h font-sm txt-fade">
										<p className="sp-right">Experience: {skill.experience}</p>
										{skill.tools && <p className="">Tools: {skill.tools.map((tool, index) => (index !== 0 ? ', ' : '') + tool)}</p>}
									</div>
									<div className="flex align-center">
										<p className="txt-fade font-sm">Confidence</p>
										<section className="full bg-secondary h rad-md ovf-hidden sp-v">
											<motion.section initial={{ width: 0 }} animate={{ width: skill.confidence }} transition={{ delay: 0.5, duration: 1.5 }} style={{}} className="bg-primary h"></motion.section>
										</section>
										<p className="font-sm txt-primary">{skill.confidence}</p>
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
			
		</React.Fragment>
	);
}

export default Skills;
